import React, { useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import './App.css';
import './styles/global.css';
import 'bootstrap/dist/css/bootstrap.min.css';
import 'owl.carousel/dist/assets/owl.carousel.css';
import 'owl.carousel/dist/assets/owl.theme.default.css';
import 'animate.css/animate.min.css';

// Import pages
import Home from './pages/Home';
import About from './pages/About';
import Gallery from './pages/Gallery';
import Video from './pages/Video';
import Contact from './pages/Contact';
import SingleProduct from './pages/SingleProduct';

// Import product pages
import AmaronProducts from './components/Products/AmaronProducts';
import ExideProducts from './components/Products/ExideProducts';
import LuminousProducts from './components/Products/LuminousProducts';
import LithiumProducts from './components/Products/LithiumProducts';
import SolarProducts from './components/Products/SolarProducts';

function App() {
  useEffect(() => {
    // Load jQuery and plugins dynamically
    const loadScripts = async () => {
      // Load jQuery if not already loaded
      if (typeof window.jQuery === 'undefined') {
        await import('jquery').then(($) => {
          window.jQuery = $;
          window.$ = $;
        });
      }
      
      // Load Owl Carousel after jQuery
      await import('owl.carousel');
      
      // Load WOW.js
      if (typeof window.WOW === 'undefined') {
        await import('wowjs').then((WOW) => {
          window.WOW = WOW.WOW;
          new window.WOW().init();
        });
      }
    };

    loadScripts();
  }, []);

  return (
    <Router>
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/about" element={<About />} />
        <Route path="/gallery" element={<Gallery />} />
        <Route path="/video" element={<Video />} />
        <Route path="/contact" element={<Contact />} />
        <Route path="/product/:productId" element={<SingleProduct />} />
        
        {/* Product Brand Pages */}
        <Route path="/exide-products" element={<ExideProducts />} />
        <Route path="/luminous-products" element={<LuminousProducts />} />
        <Route path="/lithium-products" element={<LithiumProducts />} />
        <Route path="/amaron-products" element={<AmaronProducts />} />
        <Route path="/solar-products" element={<SolarProducts />} />
      </Routes>
    </Router>
  );
}

export default App;